import type {
  FormControlProps,
  InputLabelProps,
  SelectProps as MuiSelectProps,
  SelectChangeEvent,
} from '@mui/material';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
  Typography,
} from '@mui/material';
import { ArrowMiniDown32 } from '@packages/themes/icons';

export interface SelectItem {
  value: number | string;
  label: number | string;
}

export type { SelectChangeEvent };

export interface SelectProps extends MuiSelectProps {
  /** Props passed to MUI FormControl component */
  controlProps?: FormControlProps;
  /** Props passed to MUI InputLabel component */
  labelProps?: InputLabelProps;
  /** Select label */
  label: string;
  /** Select helper text */
  helperText?: string;
  /** Items to populate the select with */
  items: Array<SelectItem>;
}

/** Select component which is populated with the injected items and rendered with input and helper labels. Based on MUI Select: https://mui.com/material-ui/react-select/ */
export const Select = ({
  controlProps,
  labelProps,
  label,
  helperText,
  items,
  ...rest
}: SelectProps) => (
  <FormControl {...controlProps} sx={{ pt: 2.25 }} data-testid="select-wrapper">
    <InputLabel id={label} {...labelProps}>
      {label}
    </InputLabel>
    <MuiSelect
      labelId={label}
      label={label}
      sx={{ pr: 1.75 }}
      data-testid="select-input"
      IconComponent={(props) => <ArrowMiniDown32 {...props} />}
      {...rest}
    >
      {items.map(({ value, label: itemLabel }) => (
        <MenuItem value={value} key={value}>
          <Typography>{itemLabel}</Typography>
        </MenuItem>
      ))}
    </MuiSelect>
    {helperText && <FormHelperText>{helperText}</FormHelperText>}
  </FormControl>
);
